module.exports = __webpack_public_path__ + "img/quaro-q-obi.c9670015.svg";